import proTable from './index.vue';

proTable.install = function (App) {
    App.component(proTable.name, proTable);
};

export default proTable;
